/* eslint-disable import/prefer-default-export, no-shadow */
export enum ProgressStep {
  START = 'Start',
  DETAILS = 'Details',
  CHECK_CONFIRM = 'Check & confirm',
  DONE = 'Done',
}

export enum ObligationStatus {
  INFRINGEMENT = 'Infringement',
  PENALTY_REMINDER = 'PenaltyReminder',
  NOTICE_OF_FINAL_DEMAND = 'NoticeOfFinalDemand',
  ENFORCEMENT_WARRANT = 'EnforcementWarrant',
}
